import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import TextField from "../../shared/TextField/index.tsx";
import Logo from "../../assets/logo.jpg";
import "../../styles/scss/Login.scss";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api/";

export default function Login() {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { username: "", password: "" },
    validationSchema: Yup.object({
      username: Yup.string().required("Username is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await fetch(`${API_URL}api/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        });
        const data = await response.json();
        if (data?.token) {
          localStorage.setItem("token", data.token);
          localStorage.setItem("userData", JSON.stringify(data.user));
          toast.success("Login successful!");
          navigate("/admin/dashboard");
        } else {
          toast.error(data?.message || "Login failed");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    },
  });

  return (
    <Box className="login-page">
      <Box className="login-bg">
        <Box className="bg-gradient"></Box>
        <Box className="bg-grid"></Box>
        <Box className="bg-overlay"></Box>
        <Box className="bg-glow bg-glow-1"></Box>
        <Box className="bg-glow bg-glow-2"></Box>
        <Box className="bg-glow bg-glow-3"></Box>

        <Box
          className="bubble"
          style={
            {
              width: 80,
              height: 80,
              bottom: -80,
              left: "10%",
              "--duration": "18s",
              "--delay": "0s",
            } as React.CSSProperties
          }
        />
        <Box
          className="bubble"
          style={
            {
              width: 50,
              height: 50,
              bottom: -50,
              left: "30%",
              "--duration": "22s",
              "--delay": "3s",
            } as React.CSSProperties
          }
        />
        <Box
          className="bubble"
          style={
            {
              width: 100,
              height: 100,
              bottom: -100,
              left: "55%",
              "--duration": "15s",
              "--delay": "1s",
            } as React.CSSProperties
          }
        />
        <Box
          className="bubble"
          style={
            {
              width: 40,
              height: 40,
              bottom: -40,
              left: "75%",
              "--duration": "20s",
              "--delay": "5s",
            } as React.CSSProperties
          }
        />
        <Box
          className="bubble"
          style={
            {
              width: 65,
              height: 65,
              bottom: -65,
              left: "90%",
              "--duration": "25s",
              "--delay": "2s",
            } as React.CSSProperties
          }
        />
      </Box>

      <Box className="login-content">
        <Box className="login-form-wrapper">
          <Box className="login-card">
            <Box className="card-accent"></Box>

            <Box className="login-header">
              <Box className="brand-icon">
                <span className="material-symbols-outlined">
                  local_car_wash
                </span>
              </Box>
              <Typography className="login-title">Welcome Back</Typography>
              <Typography className="login-desc">
                Sign in to access your dashboard
              </Typography>
            </Box>

            <Box
              component="form"
              onSubmit={formik.handleSubmit}
              className="login-form"
            >
              <Box className="form-field">
                <Typography className="field-label">Username</Typography>
                <TextField name="username" type="text" formik={formik} />
              </Box>

              <Box className="form-field">
                <Typography className="field-label">Password</Typography>
                <TextField name="password" type="password" formik={formik} />
              </Box>

              <button
                type="submit"
                className="login-btn"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    Sign In
                    <span className="material-symbols-outlined">
                      arrow_forward
                    </span>
                  </>
                )}
              </button>
            </Box>
          </Box>
        </Box>

        <Box className="login-footer">
          <Typography>
            Developed by <strong>Codechip Technologies</strong>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
